/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S7_P1Inputs */

const tr_kullanim_s7_p1 = /** @type {(inputs: Kullanim_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ ürünü, yazılımı, tasarımı ve tüm içeriği FSEK ve Sınai Mülkiyet Kanunu kapsamında korunmaktadır. ShopPanel™ ve emonse® markaları Emonse® E-Ticaret Limited Şirketi tarafından işletilmektedir. Marka tescil bilgilerimiz tüzel sicil kayıtlarımızdadır.`)
};

const en_kullanim_s7_p1 = /** @type {(inputs: Kullanim_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ShopPanel™ product, its software, its design and all of its content are protected under FSEK and Sınai Mülkiyet Kanunu. The ShopPanel™ and emonse® trademarks are operated by Emonse® E-Ticaret Limited Şirketi. Our trademark registration details are held in our corporate registry records.`)
};

const de_kullanim_s7_p1 = /** @type {(inputs: Kullanim_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Produkt ShopPanel™, seine Software, sein Design und sämtliche Inhalte sind nach FSEK und Sınai Mülkiyet Kanunu geschützt. Die Marken ShopPanel™ und emonse® werden von der Emonse® E-Ticaret Limited Şirketi betrieben. Unsere Markenregistrierungsangaben befinden sich in unseren Handelsregistereintragungen.`)
};

const ru_kullanim_s7_p1 = /** @type {(inputs: Kullanim_S7_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продукт ShopPanel™, его программное обеспечение, дизайн и всё содержимое защищены в соответствии с FSEK и Sınai Mülkiyet Kanunu. Товарные знаки ShopPanel™ и emonse® используются компанией Emonse® E-Ticaret Limited Şirketi. Сведения о регистрации наших товарных знаков содержатся в наших корпоративных реестровых записях.`)
};

/**
* | output |
* | --- |
* | "The ShopPanel™ product, its software, its design and all of its content are protected under FSEK and Sınai Mülkiyet Kanunu. The ShopPanel™ and emonse® tradem..." |
*
* @param {Kullanim_S7_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s7_p1 = /** @type {((inputs?: Kullanim_S7_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S7_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s7_p1(inputs)
	if (locale === "de") return de_kullanim_s7_p1(inputs)
	if (locale === "ru") return ru_kullanim_s7_p1(inputs)
	return tr_kullanim_s7_p1(inputs)
});